import type { Theme } from '@mui/material';
// eslint-disable-next-line no-duplicate-imports
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import { defaultTheme } from './theme';

type ThemeProviderProps = {
  theme?: Theme
};

export const ThemeProvider: React.FC<React.PropsWithChildren<ThemeProviderProps>> = ({
    children,
    theme = defaultTheme,
}) => (
    <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
    </MuiThemeProvider>
);
